module.exports = __webpack_public_path__ + "static/media/Pelvis_Acetabular and Fem.8e0552ec.png";